const autoNgTemplateLoaderTemplate1 = require('./macvlanNodesDatatable.html');

angular.module('portainer.docker').component('macvlanNodesDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    showIpAddressColumn: '<',
    accessToNodeDetails: '<',
    state: '=',
  },
});
